<template>
  <div class="modify-calculation-container">
    <div class="modify-calculation-header">
      <img @click="navigateBack" :src="backIcon" alt="Back icon" height="32px" />
      <h1>kalkuláció módosítása</h1>
    </div>

    <div v-for="section in schema" :key="section.key" class="calculation-type-container">
      <div class="form-container">
        <p class="form-header">
          {{ section.title }}
        </p>

        <div v-for="row in section.rows" :key="row.key" class="form-row">
          <label class="form-label">{{ row.label }}</label>
          <div class="input-container">
            <vpd-input v-model="form[section.key][row.key].count" type="text" placeholder="db" :isSmall="true" />
            <vpd-input v-model="form[section.key][row.key].amount" type="text" placeholder="Ft" :isSmall="true" />
          </div>
        </div>
      </div>
    </div>

    <div class="modify-button-container">
      <div class="cancel-button" @click="navigateBack">
        mégsem
      </div>
      <div class="save-button" @click="save">
        mentés
      </div>
    </div>
  </div>
</template>

<script>
import "./_Calculation.scss";
import vpdInput from "../components/vpd-input/vpd-input.vue";
import backIcon from "@/assets/arrow-left.svg";

const modifyCalculationSchema = [
  {
    key: "electronicTransfer",
    title: "utalás típusa - elektronikusan",
    rows: [
      { key: "occasional", label: "occasional" },
      { key: "regular", label: "regular" },
      { key: "groupDirectDebit", label: "csoportos beszedés" },
    ],
  },
  {
    key: "paperTransfer",
    title: "utalás típusa - papír alapon (saját fiókban)",
    rows: [
      { key: "occasional", label: "occasional" },
      { key: "regular", label: "regular" },
      { key: "directDebit", label: "beszedés" },
    ],
  },
  {
    key: "telebankTransfer",
    title: "utalás típusa - telebankban",
    rows: [
      { key: "occasional", label: "occasional" },
      { key: "regular", label: "regular" },
      { key: "directDebit", label: "beszedés" },
    ],
  },
  {
    key: "cashWithdrawal",
    title: "készpénzfelvétel",
    rows: [
      { key: "ownAtm", label: "saját ATM-ből" },
      { key: "otherAtm", label: "idegen ATM-ből" },
      { key: "ownBranch", label: "saját fiókban" },
    ],
  },
];

export default {
  name: "modify-calculation",
  components: {
    vpdInput
  },
  props: {
    config: {
      type: Object,
      required: false,
    },
    initialForm: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      value: null,
      backIcon,
      schema: modifyCalculationSchema,
      form: {
        electronicTransfer: {
          occasional: { count: null, amount: null },
          regular: { count: null, amount: null },
          groupDirectDebit: { count: null, amount: null },
        },
        paperTransfer: {
          occasional: { count: null, amount: null },
          regular: { count: null, amount: null },
          directDebit: { count: null, amount: null },
        },
        telebankTransfer: {
          occasional: { count: null, amount: null },
          regular: { count: null, amount: null },
          directDebit: { count: null, amount: null },
        },
        cashWithdrawal: {
          ownAtm: { count: null, amount: null },
          otherAtm: { count: null, amount: null },
          ownBranch: { count: null, amount: null },
        },
      },
    }
  },
  methods: {
    navigateBack: function () {
      this.$router.push({ name: "accounts" }).catch(err => {
        if (err.name !== 'NavigationDuplicated' &&
          err.message &&
          !err.message.includes('Redirected')) {
          throw err;
        }
      });
    }
  }
};
</script>
